module.exports = __webpack_public_path__ + "media/components/KnowledgeBase/pages/KnowledgeBaseList/SearchNo-d69588d3487251c00f9f6d8e0f70eeaf.png";